export const OrderStatus = [
  {
    key: "rejected",
    label: "Rejected",
    value: "rejected",
  },
  {
    key: "waiting",
    label: "Waiting",
    value: "waiting",
  },
  {
    key: "preparing",
    label: "Preparing",
    value: "preparing",
  },
  {
    key: "prepared",
    label: "Prepared",
    value: "prepared",
  },
  {
    key: "served",
    label: "Served",
    value: "served",
  },
  {
    key: "completed",
    label: "Completed",
    value: "completed",
  },
  {
    key: "waiting_for_confirmation",
    label: "waiting for confirmation",
    value: "waiting_for_confirmation",
  },
];
